export interface DestinationData {
  id: string;
  name: string;
  subtitle: string;
  description: string;
  image: string;
  location: string;
  region: string;
  elevation: string;
  bestTime: string;
  highlights: string[];
  activities: string[];
  gallery: string[];
  mapLocation: {
    lat: number;
    lng: number;
  };
  additionalDetails?: {
    altitude?: string;
    surface?: string;
    population?: string;
    density?: string;
    length?: string;
  };
}

export const destinationsData: Record<string, DestinationData> = {
  'rocca_calascio': {
    id: 'rocca_calascio',
    name: 'Rocca Calascio',
    subtitle: 'Il Borgo delle Nuvole',
    description: 'Nel cuore del Parco Nazionale del Gran Sasso e Monti della Laga, Rocca Calascio è uno dei borghi più suggestivi d\'Abruzzo. Situato a oltre 1.400 metri di altitudine, questo piccolo gioiello regala viste mozzafiato e un\'atmosfera senza tempo. Il borgo, ormai semi-abbandonato, conserva un fascino unico tra ruderi in pietra, silenzio e panorami infiniti sulle montagne abruzzesi. Un luogo perfetto per chi cerca autenticità, bellezza e una connessione profonda con la natura e la storia.',
    image: '/destinations/rocca_calascio/rocca_calascio_homepage.webp',
    location: 'Provincia di L\'Aquila, Abruzzo',
    region: 'Parco Nazionale del Gran Sasso e Monti della Laga',
    elevation: '1.460 metri',
    bestTime: 'Tutto l\'anno (primavera e autunno per temperature ideali)',
    highlights: [
      'Castello di Rocca Calascio - Tra i più alti castelli d\'Italia',
      'Chiesa di Santa Maria della Pietà - Gioiello ottagonale del XVII secolo',
      'Vista panoramica a 360 gradi',
      'Borgo medievale semi-abbandonato',
      'Sentieri panoramici nelle montagne'
    ],
    activities: [
      'Passeggiata panoramica nel borgo medievale',
      'Visita al castello e alla chiesa',
      'Fotografia paesaggistica',
      'Immersione nella storia e nella cultura locale'
    ],
    gallery: [
      '/destinations/rocca_calascio/rocca_calascio_1_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_2_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_3_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_4_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_5_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_6_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_7_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_8_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_9_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_10_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_11_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_12_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_13_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_14_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_15_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_16_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_17_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_18_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_19_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_20_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_21_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_22_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_23_medium.webp',
      '/destinations/rocca_calascio/rocca_calascio_24_medium.webp'
    ],
    mapLocation: {
      lat: 42.3283,
      lng: 13.6889
    },
    additionalDetails: {
      altitude: '1410_m_above_sea_level'
    }
  },
  'collalto_sabino': {
    id: 'collalto_sabino',
    name: 'Collalto Sabino',
    subtitle: 'Il Borgo Medievale della Sabina',
    description: 'Arroccato su un colle tra i boschi e le colline della Sabina, Collalto Sabino è uno dei borghi più belli d\'Italia, ricco di fascino medievale e panorami mozzafiato. Mura in pietra, torri, vicoli silenziosi e un castello perfettamente conservato lo rendono una tappa imperdibile per chi cerca autenticità, storia e bellezza fuori dalle rotte più turistiche. Un luogo dove il tempo sembra essersi fermato, ideale per una passeggiata rilassante e per immergersi nella magia di un\'Italia intima e nascosta.',
    image: '/destinations/collalto_sabino/collalto_sabino_homepage.webp',
    location: 'Provincia di Rieti, Lazio',
    region: 'Sabina',
    elevation: '980 metri',
    bestTime: 'Tutto l\'anno (primavera e autunno per temperature ideali)',
    highlights: [
      'Castello Baronale - Uno dei meglio conservati di architettura feudale',
      'Centro Storico Medievale - Strette vie lastricate e archi in pietra',
      'Mura in pietra e torri - Testimonianza del passato medievale',
      'Balconi fioriti e portali antichi - Bellezza architettonica',
      'Panorami mozzafiato sulle colline della Sabina'
    ],
    activities: [
      'Passeggiata nel borgo antico',
      'Esplorazione delle stradine medievali',
      'Visita ai punti panoramici',
      'Scoperta del castello baronale',
      'Immersione nella storia medievale'
    ],
    gallery: [
      '/destinations/collalto_sabino/collalto_sabino_1_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_2_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_3_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_4_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_5_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_6_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_7_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_8_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_9_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_10_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_11_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_12_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_13_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_14_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_15_medium.webp',
      '/destinations/collalto_sabino/collalto_sabino_16_medium.webp'
    ],
    mapLocation: {
      lat: 42.1574,
      lng: 13.0143
    },
    additionalDetails: {
      altitude: '980_m_above_sea_level',
      surface: '22,37 km²',
      population: '372_updated_on_30_6_2025',
      density: '16,63 ab./km²'
    }
  },
  'santo_stefano_di_sessanio': {
    id: 'santo_stefano_di_sessanio',
    name: 'Santo Stefano di Sessanio',
    subtitle: 'Il Gioiello Medievale del Gran Sasso',
    description: 'Nel cuore del Parco Nazionale del Gran Sasso, Santo Stefano di Sessanio è uno dei borghi più affascinanti d\'Abruzzo. Un piccolo gioiello medievale in pietra calcarea bianca, perfettamente integrato nel paesaggio montano circostante. Ristrutturato con grande cura, il borgo ha mantenuto intatta la sua anima antica, diventando un simbolo del turismo lento e sostenibile. Un luogo dove ogni passo racconta una storia e ogni scorcio invita alla contemplazione.',
    image: '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_homepage.webp',
    location: 'Provincia di L\'Aquila, Abruzzo',
    region: 'Parco Nazionale del Gran Sasso e Monti della Laga',
    elevation: '1.250 metri',
    bestTime: 'Tutto l\'anno (primavera e autunno per temperature ideali)',
    highlights: [
      'Centro Storico Medievale - Vie strette e tortuose con archi in pietra',
      'Torre Medicea - Simbolo del borgo risalente al XV secolo',
      'Case restaurate secondo tradizione - Armonia e autenticità',
      'Atmosfera sospesa nel tempo - Silenzio e contemplazione',
      'Panorama spettacolare sulle montagne abruzzesi'
    ],
    activities: [
      'Passeggiata nel borgo medievale',
      'Esplorazione delle viuzze e piazzette',
      'Visita alle botteghe artigiane',
      'Salita alla Torre Medicea',
      'Immersione nella bellezza silenziosa'
    ],
    gallery: [
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_1_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_2_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_3_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_4_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_5_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_6_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_7_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_8_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_9_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_10_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_11_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_12_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_13_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_14_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_15_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_16_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_17_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_18_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_19_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_20_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_21_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_22_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_23_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_24_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_25_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_26_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_27_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_28_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_29_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_30_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_31_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_32_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_33_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_34_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_35_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_36_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_37_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_38_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_39_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_40_medium.webp',
      '/destinations/santo_stefano_di_sessanio/santo_stefano_di_sessanio_41_medium.webp'
    ],
    mapLocation: {
      lat: 42.1574,
      lng: 13.0143
    },
    additionalDetails: {
      altitude: '1251_m_above_sea_level',
      surface: '33,7 km²',
      population: '106_updated_on_30_6_2025',
      density: '3,15 ab./km²'
    }
  },
  'trabocchi_coast': {
    id: 'trabocchi_coast',
    name: 'Costa dei Trabocchi',
    subtitle: 'La Costa Incantata dei Trabocchi',
    description: 'La Costa dei Trabocchi è uno dei tratti costieri più suggestivi dell\'Adriatico, caratterizzato da antiche strutture di pesca in legno che si protendono sul mare come giganti addormentati. Questa costa, che si estende per circa 70 chilometri tra Ortona e Vasto, offre un paesaggio unico dove storia, tradizione e natura si fondono in armonia perfetta. I trabocchi, antiche macchine da pesca risalenti al XVIII secolo, sono oggi simboli di un\'arte marinara che resiste al tempo, circondati da spiagge incontaminate, calette nascoste e panorami mozzafiato sul mare cristallino.',
    image: '/destinations/trabocchi_coast/trabocchi_coast_homepage.webp',
    location: 'Provincia di Chieti, Abruzzo',
    region: 'Costa Adriatica',
    elevation: '0-200 metri',
    bestTime: 'Primavera, Estate, Autunno (maggio-ottobre per temperature ideali)',
    highlights: [
      'Trabocchi Storici - Antiche strutture di pesca in legno sul mare',
      'Spiagge Incontaminate - Calette nascoste e litorali selvaggi',
      'Panorami Marini - Viste mozzafiato sull\'Adriatico',
      'Borghi Marinari - Villaggi di pescatori autentici',
      'Gastronomia Locale - Ristoranti sui trabocchi e pesce fresco'
    ],
    activities: [
      'Passeggiata lungo la costa panoramica',
      'Visita ai trabocchi storici',
      'Escursioni in barca lungo la costa',
      'Degustazione di pesce fresco',
      'Fotografia paesaggistica'
    ],
    gallery: [
      '/destinations/trabocchi_coast/trabocchi_coast_1_medium.webp',
      '/destinations/trabocchi_coast/trabocchi_coast_2_medium.webp',
      '/destinations/trabocchi_coast/trabocchi_coast_3_medium.webp',
      '/destinations/trabocchi_coast/trabocchi_coast_4_medium.webp'
    ],
    mapLocation: {
      lat: 42.3000,
      lng: 14.4000
    },
    additionalDetails: {
      altitude: '0_m_above_sea_level',
      length: '60 km'
    }
  },
  'campo_imperatore': {
    id: 'campo_imperatore',
    name: 'Campo Imperatore',
    subtitle: 'Il Piccolo Tibet d\'Abruzzo',
    description: 'Campo Imperatore è uno degli altopiani più spettacolari d\'Italia, situato nel cuore del Parco Nazionale del Gran Sasso e Monti della Laga. Conosciuto come il "Piccolo Tibet" per la sua vastità e per i panorami mozzafiato che offre, questo altopiano a oltre 1.800 metri di altitudine è un luogo di straordinaria bellezza naturale. Circondato dalle vette più alte degli Appennini, Campo Imperatore regala paesaggi lunari, praterie infinite e un\'atmosfera unica che richiama le grandi distese tibetane.',
    image: '/destinations/campo_imperatore/campo_imperatore_homepage.webp',
    location: 'Provincia di L\'Aquila, Abruzzo',
    region: 'Parco Nazionale del Gran Sasso e Monti della Laga',
    elevation: '1.800 metri',
    bestTime: 'Tutto l\'anno (estate per escursioni, inverno per sci)',
    highlights: [
      'Altopiano di Campo Imperatore - Vastità e panorami mozzafiato',
      'Rifugio Duca degli Abruzzi - Punto di riferimento storico',
      'Sentiero del Centenario - Percorso escursionistico panoramico',
      'Panorami sul Corno Grande - Vista sulla vetta più alta degli Appennini',
      'Natura incontaminata - Flora e fauna di alta quota'
    ],
    activities: [
      'Escursioni nell\'altopiano',
      'Sci alpino e sci di fondo in inverno',
      'Fotografia paesaggistica',
      'Osservazione della fauna selvatica',
      'Trekking e camminate panoramiche'
    ],
    gallery: [
      '/destinations/campo_imperatore/campo_imperatore_1_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_2_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_3_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_4_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_5_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_6_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_7_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_8_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_9_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_10_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_11_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_12_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_13_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_14_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_15_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_16_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_17_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_18_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_19_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_20_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_21_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_22_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_23_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_24_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_25_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_26_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_27_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_28_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_29_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_30_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_31_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_32_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_33_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_34_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_35_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_36_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_37_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_38_medium.webp',
      '/destinations/campo_imperatore/campo_imperatore_39_medium.webp'
    ],
    mapLocation: {
      lat: 42.4667,
      lng: 13.5667
    },
    additionalDetails: {
      altitude: 'between_1460_and_2138_meters_above_sea_level',
      surface: '75km²'
    }
  },
  'scanno': {
    id: 'scanno',
    name: 'Scanno',
    subtitle: 'Il Borgo dei Gioielli e del Lago',
    description: 'Scanno è uno dei borghi più affascinanti dell\'Abruzzo, arroccato su una collina che domina il lago omonimo. Conosciuto per la sua tradizione orafa e per i costumi tradizionali delle donne, Scanno è un gioiello architettonico e culturale che conserva intatta la sua anima antica. Il centro storico, con le sue case in pietra, le viuzze caratteristiche e i panorami mozzafiato sul lago, offre un\'esperienza unica dove storia, tradizione e bellezza naturale si fondono in perfetta armonia.',
    image: '/destinations/scanno/scanno_homepage.webp',
    location: 'Provincia de L\'Aquila, Abruzzo',
    region: 'Parco Nazionale d\'Abruzzo, Lazio e Molise',
    elevation: '1.050 metri',
    bestTime: 'Tutto l\'anno (primavera e autunno per temperature ideali)',
    highlights: [
      'Centro Storico Medievale - Viuzze in pietra e architettura tradizionale',
      'Lago di Scanno - Specchio d\'acqua cristallino circondato da montagne',
      'Tradizione Orafa - Botteghe artigiane e gioielli tradizionali',
      'Costumi Tradizionali - Abiti tipici delle donne di Scanno',
      'Panorami Montani - Viste mozzafiato sul lago e le montagne'
    ],
    activities: [
      'Passeggiata nel centro storico',
      'Visita alle botteghe orafe',
      'Escursioni intorno al lago',
      'Fotografia paesaggistica',
      'Immersione nella cultura tradizionale'
    ],
    gallery: [
      '/destinations/scanno/scanno_1_medium.webp',
      '/destinations/scanno/scanno_2_medium.webp',
      '/destinations/scanno/scanno_3_medium.webp',
      '/destinations/scanno/scanno_4_medium.webp'
    ],
    mapLocation: {
      lat: 41.9000,
      lng: 13.8833
    },
    additionalDetails: {
      altitude: '1050_m_above_sea_level',
      surface: '134,68 km²',
      population: '1679_updated_on_30_6_2025',
      density: '12,47 ab./km²'
    }
  }
};

export const getDestinationData = (destinationId: string): DestinationData | null => {
  return destinationsData[destinationId] || null;
}; 